import React, { useState } from 'react';
import { ModalWrapper } from './ModalWrapper';
import { POPUP_STYLES } from '../../constants/popupStyles';

interface MissingDocumentsModalProps {
    isOpen: boolean;
    onClose: () => void;
    onPatientContacted?: () => Promise<void>;
}

export const MissingDocumentsModal: React.FC<MissingDocumentsModalProps> = ({
    isOpen,
    onClose,
    onPatientContacted,
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handlePatientContacted = async () => {
        if (!onPatientContacted) return;

        setIsSubmitting(true);
        try {
            await onPatientContacted();
        } catch (error) {
            console.error('[MissingDocumentsModal] Error calling onPatientContacted:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <ModalWrapper modalId="MissingDocumentsModal"
            isOpen={isOpen}
            onClose={onClose}
            title="Missing Documents"
            width="max-w-md"
        >
            <div className="mb-6">
                <p className="text-gray-700 text-center">
                    Please contact patient to remind him to upload files towards next Doctor meeting.
                </p>
            </div>

            {/* Buttons */}
            <div className="flex justify-center gap-4">
                <button
                    onClick={handlePatientContacted}
                    disabled={isSubmitting}
                    className={`${POPUP_STYLES.button} ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                    {isSubmitting ? 'Processing...' : 'Patient Contacted'}
                </button>
                <button
                    onClick={onClose}
                    disabled={isSubmitting}
                    className={POPUP_STYLES.button}
                >
                    Cancel
                </button>
            </div>
        </ModalWrapper>
    );
};
